module.exports = __webpack_public_path__ + "img/서브4_공제어감각.4be21cad.svg";